import {
  PacketModule,
  createPacketServices
} from "./chunk-EQFLFMNE.mjs";
import "./chunk-Y27MQZ3U.mjs";
export {
  PacketModule,
  createPacketServices
};
